import HiveOverview from '@/views/overviews/HiveOverview.vue';
import HivesOverview from '@/views/overviews/HivesOverview.vue';
import Vue from 'vue';
import Router, { Route } from 'vue-router';
import AnonymousRoot from './views/AnonymousRoot.vue';
import Root from './views/Root.vue';
import Barometer from './views/barometer/Barometer.vue';
import AccountDetails from './views/details/AccountDetails.vue';
import OrganizationDashboard from './views/details/OrganizationDashboard.vue';
import GroupDetails from './views/details/GroupDetails.vue';
import MyDashboard from './views/details/MyDashboard.vue';
import SectorDetails from './views/details/SectorDetails.vue';
import TribeDetails from './views/details/TribeDetails.vue';
import GeneralError from './views/errors/GeneralError.vue';
import NotAllowed from './views/errors/NotAllowed.vue';
import NotFound from './views/errors/NotFound.vue';
import OperationsDashboard from './views/operations/OperationsDashboard.vue';
import AccountOverview from './views/overviews/AccountOverview.vue';
import Overview from './views/overviews/Overview.vue';
import SectorOverview from './views/overviews/SectorOverview.vue';
import TribeOverview from './views/overviews/TribeOverview.vue';
import ConsultantQuestionnaire from './views/questionnaires/ConsultantQuestionnaire.vue';
import Questionnaire from './views/questionnaires/Questionnaire.vue';
import Settings from './views/settings/Settings.vue';

import store from './store/store';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            // base route for authenticated pages
            path: '/',
            name: 'root',
            component: Root,
            beforeEnter: async (to: Route, from: Route, next: Function) => {
                await store.dispatch('fetchRoot');
                await store.dispatch('user/fetchUser');
                await store.dispatch('user/fetchActiveAllocationsForUser');
                next();
            },
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: '/barometer/:personId',
                    name: 'barometer',
                    component: Barometer
                },
                {
                    path: '/overview',
                    name: 'overview',
                    component: Overview,
                    beforeEnter: (to: Route, from: Route, next: Function) => {
                        if (store.state.user.user.isViewer) {
                            next();
                        } else {
                            next('/');
                        }
                    },
                    children: [
                        {
                            path: 'tribe',
                            name: 'tribeOverview',
                            component: TribeOverview
                        },
                        {
                            path: 'hives',
                            name: 'hivesOverview',
                            component: HivesOverview
                        },
                        {
                            path: 'hive/:id',
                            name: 'hiveOverview',
                            component: HiveOverview
                        },
                        {
                            path: 'sector',
                            name: 'sectorOverview',
                            component: SectorOverview
                        },
                        {
                            path: 'account',
                            name: 'accountOverview',
                            component: AccountOverview
                        },
                        {
                            path: 'my',
                            name: 'myDashboard',
                            component: MyDashboard
                        },
                        {
                            path: 'all',
                            name: 'allDashboard',
                            component: OrganizationDashboard
                        }
                    ]
                },
                {
                    path: '/details',
                    name: 'details',
                    component: GroupDetails,
                    children: [
                        {
                            path: 'tribe/:id',
                            name: 'tribeDetails',
                            component: TribeDetails,
                            props: true
                        },
                        {
                            path: 'sector/:id',
                            name: 'sectorDetails',
                            component: SectorDetails,
                            props: true
                        },
                        {
                            path: 'account/:id',
                            name: 'accountDetails',
                            component: AccountDetails,
                            props: true
                        }
                    ]
                },
                {
                    path: '/questionnaire/:prefilledAnswer?',
                    name: 'questionnaire',
                    component: Questionnaire,
                    redirect: { name: 'consultantQuestionnaire' },
                    beforeEnter: (to: Route, from: Route, next: Function) => {
                        if (store.state.user.user.isParticipant) {
                            next();
                        } else {
                            next('/');
                        }
                    },
                    children: [
                        {
                            path: 'consultant',
                            name: 'consultantQuestionnaire',
                            component: ConsultantQuestionnaire
                        }
                    ]
                },
                {
                    path: '/operations',
                    name: 'operationsDashboard',
                    component: OperationsDashboard,
                    beforeEnter: (to: Route, from: Route, next: Function) => {
                        if (store.state.user.user.isOps) {
                            next();
                        } else {
                            next('/error/notfound');
                        }
                    }
                },
                {
                    path: '/settings',
                    name: 'settings',
                    component: Settings,
                    beforeEnter: (to: Route, from: Route, next: Function) => {
                        if (store.state.user.user.isParticipant) {
                            next();
                        } else {
                            next('/error/notfound');
                        }
                    }
                }
            ]
        },
        // anonymous accessible pages
        {
            path: '/anon',
            name: 'anonymousRoot',
            component: AnonymousRoot,
            children: [
                {
                    path: '/error',
                    name: 'error',
                    component: GeneralError
                },
                {
                    path: '/error/notallowed',
                    name: 'notallowed',
                    component: NotAllowed
                },
                {
                    path: '/error/notfound',
                    name: 'notfound',
                    component: NotFound
                }
            ]
        },
        {
            path: '*',
            redirect: { name: 'notfound' }
        }
    ],
    scrollBehavior(to: Route, from: Route, savedPosition: void | { x: number; y: number }) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

export default router;
